// header buttons color
export const HEADER_BUTTON_COLOR_1 = "#67C451";
export const HEADER_BUTTON_COLOR_2 = "#FFFFFF";
export const HEADER_BUTTON_COLOR_3 = "#b4b8da";
export const HEADER_BUTTON_COLOR_4 = "#4B5282";
export const HEADER_BUTTON_COLOR_5 = "#B52F2A";
export const HEADER_BUTTON_COLOR_6 = "#ADB8C4";

// header buttons width class
export const HEADER_BUTTON_WIDTH_1 = "col-1";
export const HEADER_BUTTON_WIDTH_2 = "col-2";
export const HEADER_BUTTON_WIDTH_3 = "col-3";
export const HEADER_BUTTON_WIDTH_4 = "col-4";
export const HEADER_BUTTON_WIDTH_5 = "col-5";
export const HEADER_BUTTON_WIDTH_6 = "col-6";
export const HEADER_BUTTON_WIDTH_7 = "col-7";
export const HEADER_BUTTON_WIDTH_8 = "col-8";

// header button type
export const HEADER_BUTTON_TYPE_NEW = 2;
export const HEADER_BUTTON_TYPE_OTHER = 1;
